<div class="ion-padding-end ion-padding-start toolbar">
  @if(allowImpersonate() && impersonateService?.impersonate(); as impersonate) {
  <div class="impersonate-banner">
    <ion-avatar class="impersonate-banner__avatar">
      <img
        [src]="impersonate.avatar ?? '/assets/placeholder-avatar.png'"
        alt=""
      />
    </ion-avatar>
    <div class="impersonate-banner__text">
      <span class="impersonate-banner__label">{{ 'chat.impersonate.speakingAs' | translate }}</span>
      <span class="impersonate-banner__name">{{ impersonate.name }}</span>
    </div>
    <ion-button
      color="primary"
      fill="clear"
      size="small"
      class="impersonate-banner__action"
      (click)="openCharacterSelection(true)"
      [attr.aria-label]="'chat.impersonate.changeCharacter' | translate"
    >
      <ion-icon name="person" slot="icon-only"></ion-icon>
    </ion-button>
    <ion-button
      color="medium"
      fill="clear"
      size="small"
      class="impersonate-banner__action impersonate-banner__action--dismiss"
      (click)="impersonateService?.setImpersonate(undefined)"
      [attr.aria-label]="'chat.impersonate.stop' | translate"
    >
      <ion-icon name="close-outline" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
  } @else if (showCharacterPrompt()) {
  <button
    type="button"
    class="impersonate-prompt"
    (click)="openCharacterSelection()"
    [attr.aria-label]="'chat.impersonate.pickCharacter' | translate"
  >
    <ion-icon name="person" class="impersonate-prompt__icon"></ion-icon>
    <span class="impersonate-prompt__label">{{ 'chat.impersonate.pickCharacter' | translate }}</span>
    <ion-icon name="chevron-forward" class="impersonate-prompt__chevron"></ion-icon>
  </button>
  }
  <div class="toolbar-content">
    <div class="edit-area" (click)="toggleFab.emit()">
      @if(imageSelected()){
      <img [src]="imageSelected()?.webPath" />
      <ion-button class="absolute top-2 right-2" shape="round" size="small" (click)="removeImage.emit()"
        [attr.aria-label]="'chat.actions.removeImage' | translate"><ion-icon
          name="close" slot="icon-only"></ion-icon></ion-button>
      }
      <div class="text-area">
        @if(quotedMessage(); as quote){
        <div class="composer-quote">
          <div class="composer-quote__body">
            <span class="composer-quote__author">
              @if(quote.impersonate) {
              {{ quote.impersonateData?.name }}
              } @else {
              {{ quote.userData?.displayName }}
              }
            </span>
            <div class="composer-quote__text">
              <re-message-content [content]="quote.text" [preview]="true"></re-message-content>
            </div>
          </div>
          <ion-button
            color="medium"
            fill="clear"
            size="small"
            class="composer-quote__dismiss"
            (click)="$event.stopPropagation(); quoteMessageHandler.emit()"
            [attr.aria-label]="'chat.impersonate.removeQuote' | translate"
          >
            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
        }
        <div class="text-area-container">
          <re-chat-field [quotationEntity]="quotables()" [allowOperation]="allowOperation()" type="mini"
            [refreshVersion]="editorRefreshVersion()"
            [placeholder]="writePlaceholder()" [(text)]="text"></re-chat-field>
          <div #secondActions class="second-actions"></div>
        </div>
      </div>
    </div>
    <ion-fab #fabActionsList class="fabActions" (click)="openBackdrop.emit()">
      <ion-fab-button class="sendButton" shape="round" [attr.aria-label]="'chat.actions.more' | translate">
        <ion-icon name="grid-outline"></ion-icon>
      </ion-fab-button>
      <ion-fab-list side="top">
        <ion-fab-button color="primary" class="sendButton" shape="round" type="button" (click)="sendMessage.emit()"
          [attr.aria-label]="'chat.actions.send' | translate">
          <ion-icon name="send"></ion-icon>
        </ion-fab-button>
        @if (allowImage()) {
        <ion-fab-button color="primary" class="sendButton" shape="round" type="button" (click)="addImage.emit()"
          [attr.aria-label]="'chat.actions.addImage' | translate">
          <ion-icon name="image-outline"></ion-icon>
        </ion-fab-button>
        }
        @if(allowModalEditor()){
        <ion-fab-button color="primary" class="sendButton" shape="round" type="button" (click)="openModal.emit()"
          [attr.aria-label]="'chat.actions.openEditor' | translate">
          <ion-icon name="expand-outline"></ion-icon>
        </ion-fab-button>
        }
        @if(showMaster()) {
        <ion-fab-button
          class="sendButton footer-master-fab footer-master-fab--narrator"
          shape="round"
          [class.footer-master-fab--loading]="masterBusy()"
          [attr.aria-busy]="masterBusy()"
          [attr.aria-label]="'chat.invokeMaster.prompt' | translate"
          (click)="openMasterAlert()"
        >
          @if (masterBusy()) {
          <ion-spinner class="footer-master-fab-spinner" name="crescent"></ion-spinner>
          } @else {
          <ion-icon name="sparkles-outline"></ion-icon>
          }
        </ion-fab-button>
        }
        @if(showLore()) {
        <ion-fab-button
          class="sendButton footer-lore-fab footer-master-fab--narrator"
          shape="round"
          [class.footer-master-fab--loading]="masterBusy()"
          [attr.aria-busy]="masterBusy()"
          [attr.aria-label]="'chat.invokeLore.prompt' | translate"
          (click)="openLoreAlert()"
        >
          @if (masterBusy()) {
          <ion-spinner class="footer-master-fab-spinner" name="crescent"></ion-spinner>
          } @else {
          <ion-icon name="help-circle-outline"></ion-icon>
          }
        </ion-fab-button>
        }
      </ion-fab-list>
    </ion-fab>
  </div>
</div>
